import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Img } from 'react-image';
import { Trans, withI18n } from '@lingui/react';
import Highlighter from 'react-highlight-words';
import find from 'lodash/find';

import LimitText from './utils/LimitText';
import { getAssetURL, getProductImageUrl } from '../api';
import { getLocaleFromLanguageCode } from '../intl-helpers';
import { getDetailValue } from '../utils/dataFormaters';
import { AddToCollectionBtn } from './AddToCollectionModal';
import { DeleteArticleBtn } from './DeleteArticleBtn';
import { connect } from 'react-redux';
import { selectors } from '../reducers/appReducer';
import { useAssetPreview } from '../hooks/useAssetPreview';
import noPhotoImg from '../images/no-photo.png';

function getProperty(code, productProperties) {
    return productProperties[code];
}

function getPropertyValue(code, itemProps) {
    return find(itemProps, (prop) => prop.property === code);
}

const RowDetailed = ({
         item,
         q,
         onSelect,
         availableProps,
         showLists,
         deleteProductsGrant,
         language,
         productProperties,
         i18n,
         priceDecimalPrecision,
         state,
     }) => {
    const getPropertyDetailValue = (code) => {
        const locale = getLocaleFromLanguageCode(language);

        return getDetailValue(
            getPropertyValue(code, item.children),
            getProperty(code, productProperties),
            locale,
            productProperties,
            i18n,
            priceDecimalPrecision
        );
    };

    const prezzo = getPropertyDetailValue('prezzo_listino');
    const validita_prezzo = getPropertyDetailValue('data_inizio_validita_prezzo');

    // Get dell' url dell'immagine
    const { url: itemImageUrl = null, publicUrl: itemImagePublicUrl = null } = getProductImageUrl(item) || {};

    // Aggiunto una variabile locale per gestire l' url dell' item costruito da getAssetUrl
    const assetItemImageUrl = getAssetURL(encodeURIComponent(itemImageUrl))

    // Get dell' url dell' image placeholder
    const imagePlaceholder = state ? selectors.getDefaultPlaceholderImage(state)?.imageUrl : null;
    const imagePlaceholderUrl = imagePlaceholder === './images/no-photo.png' ? noPhotoImg : (imagePlaceholder || noPhotoImg);

    // Get dell' anteprima dell' image tramite l' hook per il file singolo (da uniformare in unico hook)
    const shouldUsePreview = !itemImageUrl || !itemImageUrl.startsWith('http');
    const { previewImage, loading: imageLoading, error: imageError } = useAssetPreview(
        shouldUsePreview ? itemImagePublicUrl : null
    );

    // Url finale da usare in <Img>
    const finalImageUrl = itemImageUrl && itemImageUrl.startsWith('http')
        ? itemImageUrl
        : (assetItemImageUrl || itemImagePublicUrl)

    return (
        <Fragment>
            <td>
                {(showLists || deleteProductsGrant) && (
                    <div
                        className="flex items-center ml-1 pt-0.5"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <label
                            className="checkmark-container"
                            onClick={(e) => {
                                e.stopPropagation();
                                onSelect(item.id);
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={item.isSelected}
                                onClick={(e) => e.stopPropagation()}
                                onChange={() => {}}
                            />
                            <span className="checkmark"></span>
                        </label>
                        {showLists && <AddToCollectionBtn itemId={item.id} />}
                        {deleteProductsGrant && (
                            <DeleteArticleBtn
                                code={getPropertyDetailValue('codice_articolo')}
                                id={item.id}
                            />
                        )}
                    </div>
                )}
                <div className="table-img-preview">


                    <Img
                        src={finalImageUrl}
                        className="img-responsive m-a"
                        loader={
                            <div className="rounded bg-secondary table-img-preview" />
                        }
                        // Fallback, uso unloader di Img
                        unloader={
                            <img
                                src={imagePlaceholderUrl}
                                className="img-responsive m-a"
                                style={{ maxHeight: '145px' }}
                                alt="Placeholder"
                            />
                        }
                        style={{
                            maxHeight: '145px',
                        }}
                    />
                </div>
            </td>
            <td colSpan="6">
                <div>
                    <span className="text-large">
                        <Highlighter
                            searchWords={[q]}
                            textToHighlight={
                                getPropertyDetailValue('codice_articolo') || ''
                            }
                        />
                    </span>
                    <br />
                    <span
                        className="text-uppercase"
                        dangerouslySetInnerHTML={{
                            __html: getPropertyDetailValue('descrizione_articolo'),
                        }}
                    />
                </div>
                <div className="columns" style={{ marginTop: 30 }}>
                    <div className="column col-3">
                        {availableProps.includes('descrizione_marca') && (
                            <>
                                <span className="text-label text-uppercase">
                                    <Trans id="brand" />
                                </span>
                                <br />
                                <LimitText
                                    limit={20}
                                    text={getPropertyDetailValue('descrizione_marca')}
                                />
                            </>
                        )}
                    </div>
                    <div className="column col-3">
                        {availableProps.includes('serie') && (
                            <>
                                <span className="text-label text-uppercase">
                                    <Trans id="series" />
                                </span>
                                <br />
                                <LimitText
                                    limit={23}
                                    text={getPropertyDetailValue('serie')}
                                />
                            </>
                        )}
                    </div>
                    <div className="column col-3">
                        {availableProps.includes('linee') && (
                            <>
                                <span className="text-label text-uppercase">
                                    <Trans id="line" />
                                </span>
                                <br />
                                <LimitText
                                    limit={23}
                                    text={getPropertyDetailValue('linea')}
                                />
                            </>
                        )}
                    </div>
                    <div className="column col-3">
                        {availableProps.includes('modello') && (
                            <>
                                <span className="text-label text-uppercase">
                                    <Trans id="model" />
                                </span>
                                <br />
                                <LimitText
                                    limit={23}
                                    text={getPropertyDetailValue('modello')}
                                />
                            </>
                        )}
                    </div>
                </div>
            </td>
            <td>
                <div className="container">
                    <div className="table-cell-grid">
                        <div className="text-center">
                            {availableProps.includes('unita_ordine') && (
                                <>
                                    <span className="text-label text-uppercase">
                                        <Trans id="um" />
                                    </span>
                                    <br />
                                    <span
                                        className="tooltip"
                                        data-tooltip={getPropertyDetailValue(
                                            'unita_ordine'
                                        )}
                                    >
                                        {getPropertyDetailValue('unita_ordine')}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="table-cell-grid">
                        <div className="text-center pt-2">
                            {availableProps.includes('unita_per_prezzo') && (
                                <>
                                    <span className="text-label text-uppercase">
                                        <Trans id="conf" />
                                    </span>
                                    <br />
                                    {getPropertyDetailValue('unita_per_prezzo')}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </td>
            <td className="text-right">
                <Fragment>
                    <span className="table-price-lg">{prezzo && `€ ${prezzo}`}</span>
                    <br />
                    {validita_prezzo && (
                        <span className="table-date-sm">
                            <Fragment>
                                <Trans id="from" /> {validita_prezzo}
                            </Fragment>
                        </span>
                    )}
                </Fragment>
            </td>
        </Fragment>
    );
};

RowDetailed.propTypes = {
    bg: PropTypes.string,
    index: PropTypes.number,
    onCloseButtonClick: PropTypes.func,
    showDetails: PropTypes.bool,
    showLists: PropTypes.bool,
    state: PropTypes.object,
    item: PropTypes.object,
    q: PropTypes.string,
    onSelect: PropTypes.func,
    availableProps: PropTypes.array,
    deleteProductsGrant: PropTypes.bool,
    language: PropTypes.string,
    productProperties: PropTypes.object,
    i18n: PropTypes.object,
    priceDecimalPrecision: PropTypes.number,
};

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(withI18n()(RowDetailed));